<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.1825 12.0745C19.5944 12.4901 19.6072 13.1774 19.2112 13.6096L12.7457 20.6668C12.5507 20.8797 12.2814 21 12 21C11.7186 21 11.4493 20.8797 11.2543 20.6668L4.78879 13.6096C4.3928 13.1774 4.40564 12.4901 4.81748 12.0745C5.22931 11.6589 5.88418 11.6724 6.28017 12.1046L10.9655 17.2187L10.9655 3.08571C10.9655 2.48609 11.4287 2 12 2C12.5713 2 13.0345 2.48609 13.0345 3.08571L13.0345 17.2187L17.7198 12.1046C18.1158 11.6724 18.7707 11.6589 19.1825 12.0745Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'OrderDown' };
</script>
